// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ContactDetailsForm_loaderContainer__6Dy5M","simpleWhiteSpinner":"ContactDetailsForm_simpleWhiteSpinner__RQ-8q","spin":"ContactDetailsForm_spin__Q9OvP"};